import { useContext, useEffect, useState } from 'react'
import { getRequest, postRequest } from '../../services/base'
import LinkWithStatus from '../common/LinkWithStatus'
import { NavContext } from '../../context/global_context'
import { useParams } from 'react-router-dom'
import { ProgresSpinner } from '../common/ProgresSpinner'
import DropDownMenu from '../common/DropDownMenu'
import { downloadErrorLogs } from '../../utils/common'
import DtcValidationRunner from '../vehicle/dtc_mapping_errors/DtcValidationRunner'

const DtcValidationButton = ({ setProgressMessage }) => {
  const { vehicle } = useParams()
  const [state, dispatch] = useContext(NavContext)
  const [enableValidationBtn, setEnableValidationBtn] = useState(true)
  const [dtcValidationLogs, setDtcValidationLogs] = useState([])

  useEffect(() => {
    checkValidationFetchingProgress()
  }, [])

  const checkValidationFetchingProgress = async () => {
    let res = await getRequest(`/api/dtc_validation/status/${vehicle}/`)
    setDtcValidationLogs(res?.data?.logs)
    if (res?.data?.validation_result_status) {
      setEnableValidationBtn(false)
      setProgressMessage(res?.data?.current_step)
      setTimeout(() => {
        checkValidationFetchingProgress()
      }, 30000)
    } else {
      setEnableValidationBtn(true)
      setProgressMessage(null)
    }
  }

  const fetchValidatedRecords = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'We are starting process ...',
        showLoader: true,
      },
      notification: {},
    })
    let res = await postRequest(`/api/dtc_validation/fetch-data/`, {
      vehicle: vehicle,
    })
    if (res?.status) {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: `Process Successfully Started`,
        },
      })
    } else {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
        },
      })
    }
  }

  return enableValidationBtn ? (
    <>
      {dtcValidationLogs?.length > 0 && (
        <div
          className="text-underline cm-link text-white cursor-pointer"
          onClick={() => {
            downloadErrorLogs(dtcValidationLogs, 'error-logs.txt')
          }}
        >
          Download Logs
        </div>
      )}

      <LinkWithStatus
        href={`/administration/dtc_mapping_errors`}
        className={`cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded `}
        title="Fetch Records"
        onClickFunc={() => {
          fetchValidatedRecords()
        }}
      />

      <DtcValidationRunner
        checkValidationFetchingProgress={() => {
          checkValidationFetchingProgress()
        }}
      />
    </>
  ) : (
    <>
      <LinkWithStatus
        href={`/administration/dtc_mapping_errors`}
        className={`cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded `}
        title={<ProgresSpinner caption={`Processing Files`} />}
        onClickFunc={() => {
          alert(`You can't perform we are processing dtc validation files.`)
        }}
      />
    </>
  )
}

export default DtcValidationButton
